import {backAdmin} from "@/lib/api/axios";

export const howToVideosApi = [
   {url: `${backAdmin}/how-to-videos`, name: 'howToVideos.list', method: 'GET'},
   {url: `${backAdmin}/how-to-videos`, name: 'howToVideos.create', method: 'POST'},
   {url: `${backAdmin}/how-to-videos/{id}`, name: 'howToVideos.update', method: 'PUT'},
   {url: `${backAdmin}/how-to-videos/{id}`, name: 'howToVideos.delete', method: 'DELETE'},
]